module.exports = __webpack_public_path__ + "img/fam_wxmafiagangs.6f90b16.png";